<template>
    <div>
        <div
            id="profile-component"
            class="profile-component"
            @click="handleClickUserSettings"
        >
            <div class="container-profile">
                <div class="circle">
                    <img v-if="photo" class="circle--image" :src="photo" />
                </div>
                <div v-if="showTextInfo" class="container-data">
                    <div class="fullName">
                        <p class="fullName_p">{{ fullName }}</p>
                    </div>
                    <div v-if="!isBackoffice()" class="email">
                        <p>{{ email }}</p>
                    </div>
                    <div v-else class="company">
                        <p>{{ company }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        showTextInfo: {
            type: Boolean,
        },
    },
    data() {
        return {
            photo: "",
        };
    },
    watch: {
        computedPhoto: {
            handler: function (newValue, oldValue) {
                if (newValue) {
                    this.photo = this.computedPhoto;
                }
            },
            immediate: true,
            deep: true,
        },
    },
    computed: {
        userInfo() {
            return this.$store.getters["auth/getState"];
        },
        userAuthCheck() {
            return this.userInfo.acceptedTerms && this.userInfo.token;
        },
        email() {
            return this.userInfo.email || "";
        },
        company() {
            return this.userInfo.company || "";
        },
        fullName() {
            return this.userInfo.fullName || "";
        },
        computedPhoto() {
            return this.userInfo.photo;
        },
    },
    methods: {
        isBackoffice() {
            return this.$route.fullPath.includes("backoffice");
        },
        handleClickUserSettings() {
            if (this.userAuthCheck) {
                let hasParams = null;
                if (this.$route.params && Object.keys(this.$route.params).length > 0) {
                  hasParams = this.$route.params;
                }
                const currentPath = this.$route.name;

                if (this.isBackoffice()) {
                    this.$router.push({ name: "backoffice-user-config", params: { lastPath: currentPath, ...hasParams } });
                } else {
                    this.$router.push({ name: "user-config", params: { lastPath: currentPath, ...hasParams } });
                }
            }
        },
    },
};
</script>

<style lang="scss">
@import "@sass/_variables.scss";

#profile-component {
    .container-profile {
        font-family: Lato, "sans-serif";
        display: flex;

        .ellipse {
            display: flex;
            flex-direction: column;
            margin-top: 13px;
            margin-right: 10px;

            .dot {
                width: 3px;
                height: 3px;
                background: white;
                -moz-border-radius: 5px;
                -webkit-border-radius: 5px;
                border-radius: 5px;
                margin-top: 3px;
            }
        }
        .circle {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 40px;
            height: 40px;
            font-size: 16px;
            font-weight: 450;
            color: #9e9d9d;
            background-color: #e6e5e5;
            border-radius: 50px;

            // Inserido pelo vue via js
            .circle--image {
                border-radius: 100px;
                width: 40px;
                height: 40px;
                object-fit: cover;
            }

            .paragrafo {
                font-size: 16px;
                margin-bottom: 0;
                margin-right: 2px;
            }
        }

        .container-data {
            margin: 3px 0 3px 10px;
            display: flex;
            flex-flow: column nowrap;

            .email {
                font-size: 12px;
                color: #707070;
            }
            .email p {
                margin-bottom: 0px;
            }
            .company {
                font-size: 12px;
                color: #e6e9eb;
            }
            .company p {
                margin-bottom: 0px;
            }

            .fullName {
                font-size: 14px;
                font-weight: 400;
                letter-spacing: 0.28px;
                line-height: 15px;
                text-size-adjust: 100%;
                margin-top: 3px;
            }
            .fullName p {
                margin-bottom: 0px;
                color: var(--v-primary-base) !important;
            }
        }
    }
}
</style>
